// extracted by mini-css-extract-plugin
export var legendIndicator = "_da-1";
export var legendRight = "_da-0";